import { pgTable, uuid, text, jsonb, timestamp, index } from "drizzle-orm/pg-core";
import { organisations } from "./organisations";
import { organisationIntegrations } from "./integrations";
export var EventSource;
(function (EventSource) {
    EventSource["STRIPE"] = "stripe";
    EventSource["POSTHOG"] = "posthog";
    EventSource["GITHUB"] = "github";
    EventSource["GMAIL"] = "gmail";
    EventSource["GCAL"] = "gcal";
    EventSource["NOTION"] = "notion";
    EventSource["LINEAR"] = "linear";
    EventSource["INTERNAL"] = "internal";
    EventSource["OTHER"] = "other";
})(EventSource || (EventSource = {}));
export const events = pgTable("events", {
    id: uuid("id").primaryKey().defaultRandom(),
    organisationId: uuid("organisation_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    integrationType: text("integration_type").$type(),
    integrationId: uuid("integration_id").references(() => organisationIntegrations.id, {
        onDelete: "set null",
    }),
    eventType: text("event_type"),
    rawPayload: jsonb("raw_payload").notNull().default({}),
    receivedAt: timestamp("received_at", { withTimezone: true }).notNull().defaultNow(),
    processedAt: timestamp("processed_at", { withTimezone: true }),
    status: text("status"),
    expiresAt: timestamp("expires_at", { withTimezone: true }),
    payload: jsonb("payload").notNull().default({}),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
}, table => ({
    organisationCreatedIdx: index("idx_events_organisation_created").on(table.organisationId, table.createdAt),
    integrationIdx: index("idx_events_integration_received").on(table.integrationType, table.integrationId, table.receivedAt),
    integrationTypeIdx: index("idx_events_integration_type").on(table.integrationType),
}));
